import React from "react";
import { Input } from "@chakra-ui/react";

const DynamicInput = ({
  type,
  placeholder,
  reff,
  value,
  onChange,
  add,
  ...restProps
}) => {
  return (
    <Input
      ref={reff}
      borderRadius="md"
      backgroundColor="white"
      border="1px solid"
      borderColor="gray.200"
      mb={add && add ? "0px" : "12px"}
      type={type}
      placeholder={placeholder}
      fontSize="xl"
      size="lg"
      autoComplete="off"
      onChange={onChange}
      value={value}
      required
      _hover={{
        borderColor: "teal.500",
      }}
      _focus={{
        borderColor: "teal.500",
        boxShadow: "0 0 0 1px teal.500",
      }}
      _active={{
        bg: "white",
      }}
      {...restProps}
    />
  );
};

export default DynamicInput;
